import {
  // drawerWidth,
  transition,
  container
} from "../../eclipse.js";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    // [theme.breakpoints.up("md")]: {
    //   width: `calc(100% - ${drawerWidth}px)`
    // },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "4.8em",
    padding: "15px",
    minHeight: "calc(100vh - 6.8em)",
    // backgroundColor: whiteColor,
    // border: "1px solid"
  },
  container,
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
